export const FILTER_NAME = 'picklist'
